export default __webpack_public_path__ + "assets/weather_mobile.png";